import classNames from 'classnames';
import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { unitMapping, type Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

const Root = styled(Vertical).attrs({ gap: 0, center: true })`
  --c-projection-color: var(--c-black);
  border-radius: 50%;
  background-color: var(--c-projection-color);
  border: 1px solid var(--c-nd-100);
  width: 100%;
  height: 100%;

  &.inverted {
    --c-projection-color: var(--c-nd-100);
    border: 1px solid var(--c-projection-color);
    background-color: var(--c-black);
  }
`;

type Props = {
  size: Unit;
  children: ReactNode;
  inverted: boolean;
  color: Color;
};

export const Projection = ({ size, children, inverted, color }: Props) => {
  return (
    <Root
      style={
        {
          '--c-projection-color': color,
          ...(size
            ? {
                width: unitMapping[size],
                height: unitMapping[size],
              }
            : {}),
        } as CSSProperties
      }
      className={classNames({
        inverted,
      })}
      color={color}
    >
      {children}
    </Root>
  );
};
